import { Pool } from '../logic/pools/Pool'

export type Address = string
// BigNumber might be confused with ether.js / web3.js types
export type BigValue = string
export type Wei = string
export type Timestamp = number
export type Url = string
export type Account = string
export type OptionalAccount = string | undefined

export interface ChainConfiguration {
  chain: string
  network: string
  appId: number
  nativeCurrency: {
    name: string
    symbol: string // 2-6 characters long
    decimals: number
  }
  rpcUrls: Url[]
  blockExplorerUrls: Url[]
  getExplorerUrl: (transactionHash: string) => string
  getExplorerPoolUrl: (transactionHash: string) => string
}

export interface ChainDefinition {
  name: string
  id: number
  production: boolean
}

export const RINKEBY: ChainDefinition = {
  id: 4,
  name: 'Rinkeby',
  production: false,
}

export type VoidFunction = () => void

export type HasInjectedWeb3 = {
  ethereum?: any
  web3?: any
  navigator: any
}

export interface HasApplicationContext {
  applicationContext: {
    availableProviders: string[]
    selectedProvider: string
    addProvider: (p: string) => void
    wrongNetwork: boolean
    selectedPool: Pool | undefined
    page: string
    optionTab: '1-asset' | 'all-asset'
    dismissedAlertBanner: boolean | undefined
  }
}

export type InjectedWindow = Window &
  typeof globalThis &
  HasInjectedWeb3 &
  HasApplicationContext

export enum SmartContractAction {
  ONE_ASSET_JOIN = 1,
  MULTI_ASSET_JOIN,
  ONE_ASSET_EXIT,
  MULTI_ASSET_EXIT,
  SWAP_GIVEN_IN,
  SWAP_GIVEN_OUT,
  ONE_ASSET_JOIN_VIA_ZEROX,
}
